// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__305eA","log":"ModalInventoryLogs_log__bIhHy","date":"ModalInventoryLogs_date__1dlz5","userName":"ModalInventoryLogs_userName__3POBZ"};